'use strict';

/* jshint -W098 */
angular.module('mean.foreman').controller('ForemanPastReportController', ['$scope', '$rootScope', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectTasks', '$filter', 'Projects', '$location', 'ProjectHours', 'toaster', 'userService', 'Trades', 'aceUtils', 'tradeCodeService', '$q', 'ngDialog', 'Hours', 'myCoordinates', 'Timecards', 'PayPeriodService', 
  function($scope, $rootScope, Users, Global, Foreman, MeanUser, ProjectTasks, $filter, Projects, $location, ProjectHours, toaster, userService, Trades, aceUtils, tradeCodeService, $q, ngDialog, Hours, myCoordinates, Timecards, PayPeriodService) {
    $scope.global = Global;
    $scope.package = {
      name: 'foreman'
    };

    $scope.startDate = 0;
    $scope.endDate = 0;
    $scope.dateFormat = 'MM/DD/YYYY';
    $scope.dateFormatFull = 'MM/DD/YYYY : HH:mm:ss';

    $scope.menu = ['Payroll Period', 'Search Reports', 'Time Cards'];
    $scope.current_menu = 'Payroll Period';

    $scope.tasks = [];
    $scope.hours = [];
    $scope.report_dates = [];
    $scope.view = '';
    $scope.total_hours = 0;
    $scope.total_costs = 0;
    $scope.report_view = 'task';
    $scope.working_projects = [];
    $scope.is_manager = false;
    $scope.is_foreman = false;
    $scope.is_admin = false;
    $scope.viewingCurrentWeek = true;
    $scope.shouldShowSpinner = true;
    $scope.x = 0;
    $scope.y = 0;
    var loginDialog = null;
    $scope.userIsVerified = false;
    $scope.biweekly = false;
    $scope.userTotals = {};
    $scope.employees = [];
    $scope.selectedEmployee= null;
    $scope.userTimeCard= {};
    $scope.all_employees = [];
    $scope.fm_employees = [];
    $scope.pay_periods = [];
    $scope.login_roles = [];
    $scope.original_user = MeanUser.user;
    $scope.user = MeanUser.user;

    $scope.original_role_admin = false;

    if($scope.original_user.roles[0] == 'tm_admin') {
        $scope.original_role_admin = true;
    }

    _.each($scope.user.roles, function(role) {
        if(role === 'tm_admin') {
            $scope.is_manager = true;
            $scope.is_admin = true;
        } else if(role === 'tm_office') {
            $scope.is_manager = true;
            $scope.is_admin = true;
        } else if (role === 'tm') {
            $scope.is_manager = true;
        } else if(role === 'foreman') {
            $scope.is_foreman = true;
        }
    });

    Users.query({'trade': $scope.user.trade[0],
        'contractor_code': $scope.user.contractor_code}, function(users) {
        
        $scope.users = $filter('orderBy')(users, 'name');

        _.each($scope.users, function(user) {
            if(user.roles[0] != 'tradesman') {
                $scope.login_roles.push(user);
            }
        });

        if($scope.is_manager || $scope.is_foreman) {
            var users = $filter('filter')($scope.users, {'roles': 'foreman'}, true);
            $scope.current_foremen = $filter('orderBy')(users, 'name');

            $scope.current_foremen.unshift({
                name: "ALL"
            });

            var tradesmen = $filter('filter')($scope.users, {'roles': 'tradesman'}, true);
            _.each(users, function(user) {
                tradesmen.push(user);
            });

            $scope.all_employees = $filter('orderBy')(tradesmen, 'name');
        } 

        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;

            Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                trade[0].company_code =
                        aceUtils.padDigits(trade[0].company_code, 3);
                trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                $scope.trade = trade[0];

                if(!$scope.trade.payroll_end_date || !$scope.trade.payroll_period) {
                    toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                    return;
                }

                if($scope.trade.payroll_period === 'biweekly') {
                    $scope.biweekly = true;
                }

                $scope.pay_periods = PayPeriodService.setPayPeriods($scope.trade);
                //$scope.pay_periods = $scope.pay_periods.slice(Math.max($scope.pay_periods.length - 8, 1));
                $scope.pay_periods.reverse();

                // $scope.selectedPayPeriod = $scope.pay_periods[0];

                // $scope.payStartDate = moment($scope.selectedPayPeriod.start);
                // $scope.payEndDate = moment($scope.selectedPayPeriod.end);
                // $scope.payToday = moment();

                // $scope.getHours(true);
                $scope.shouldShowSpinner = false;
            });
        });
    });

    $scope.changePayPeriod = function() {
        //$scope.shouldShowSpinner = true;

        $scope.payStartDate = moment($scope.selectedPayPeriod.start);
        $scope.payEndDate = moment($scope.selectedPayPeriod.end);
        $scope.payToday = moment();
        //$scope.getHours(true);
        $scope.getUserHours($scope.selectedEmployee);
    };

    $scope.changePayrollPeriod = function() {
        if(typeof $scope.selectedPayPeriod == 'undefined') {
            toaster.pop('error', 'Pay Period Selection Error',
                'You must select the pay period in order to build the table.');
            return;
        }

        $scope.shouldShowSpinner = true;

        $scope.payStartDate = moment($scope.selectedPayPeriod.start);
        $scope.payEndDate = moment($scope.selectedPayPeriod.end);
        $scope.payToday = moment();
        $scope.getHours(true);
    };

    $scope.getHours = function(buildTable) {
        if($scope.is_admin) {
            $scope.getAdminHours().then(function() {
                if(buildTable)
                    $scope.buildPayrollTable();
            });
        } else if($scope.is_manager) {
            console.log('get manager hours');
            $scope.getManagerHours().then(function() {
                if(buildTable)
                    $scope.buildPayrollTable();
            });
        } else if($scope.is_foreman) {
            console.log('get foreman hours');
            $scope.getForemanHours().then(function() {
                if(buildTable)
                    $scope.buildPayrollTable();
            });
        } else {
            if(buildTable)
                $scope.buildPayrollTable();
        }
    };

    $scope.buildPayrollTable = function() {
        $scope.employees = $filter('unique')($scope.payroll_hours, 'username');
        $scope.employees = $filter('orderBy')($scope.employees, 'name');
        $scope.pay_dates = [];
        var users = angular.copy($scope.users);

        var current_date = moment($scope.payStartDate);
        while(!$scope.payEndDate.isSame(current_date, 'day')) {
            $scope.pay_dates.push(moment(current_date));

            current_date = current_date.add(1, 'day');
        }   

        $scope.pay_dates.push(moment(current_date));

        console.log('building the data table');
        _.each(users, function(emp) {
            emp.grand_total = 0;
            emp.payroll_hours = [];
            _.each($scope.pay_dates, function(day) {
                var first_list = $filter('filter')($scope.payroll_hours, {
                    'username': emp.username }, true);

                var hours = 0;
                var diff_proj_hours = false;
                var data = [];
                var project_names = [];
                _.each(first_list, function(item) {
                    if(moment(item.date).isSame(day, 'day')) {
                        if(!item.project_task_id) {
                            toaster.pop('error', 'Project Hour/Task Association Error',
                                'Task for username ' + item.username + ' has an entry that has an association error.' +
                                ' This error can be fixed in database Labor.');
                        } else {
                            data.push({
                                hours: angular.copy(item.hours),
                                project: item.project_id.name,
                                manager_id: item.project_task_id.trade_manager_id,
                                foreman_id: item.foreman_id,
                                diff_proj_hours: (item.different_project) ? true : false
                            });
                        }
                    	hours += item.hours;
                        if(project_names.indexOf(item.project_id.name) === -1) {
                            project_names.push(item.project_id.name);
                        }
                    }
                });

                //need to store the hours but also note what
                //kind of hours they are so we can control
                //the display better.
                if(day <= moment()) {
                    emp.payroll_hours.push({
                    	hours: angular.copy(hours),
                        project_names: project_names,
                        data: data
                    });
                    emp.grand_total += hours;
                } else {
                    emp.payroll_hours.push({
                    	hours: 0,
                    	type: 'future'
                    });
                }
            });
        }); 

        //remove any employee that does not have hours
        _.remove(users, function(usr) {
            return usr.grand_total === 0 || $scope.removeNoRegularHours(usr);
        });

        //now users contains anyone who has time for us but
        //we need to set the type for any we missed.
        _.each(users, function(user) {
            _.each(user.payroll_hours, function(hour) {
                if(!hour.type) {
                    hour.type = 'regular';
                } 
                var found = false;
                _.each(hour.data, function(data) {
                    if(data.foreman_id === $scope.user._id) {
                        found = true;
                    }
                });

                if($scope.is_foreman && !found && hour.hours) {
                    hour.type = 'offhours';
                }
            });
        });

        var start = $scope.payStartDate.toDate();
        var end = $scope.payEndDate.toDate();

        Timecards.query({'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'type': 'DatabaseAllDateRange',
            'start_date': start,
            'end_date': end }, function(timecardDB) {

            _.each(timecardDB, function(tc) {
                var inlist = $filter('filter')(users, {'_id': tc.user._id}, true)[0];

                if(inlist) {
                    inlist.tc_signed = tc.signed;
                }
            });

            $scope.shouldShowSpinner = false;
            $scope.all_users = users;
        });
    };

    $scope.removeNoRegularHours = function(user) {
        if($scope.is_admin) return false;
        var remove = true;

        if($scope.is_manager) {
            for(var i=0; i<user.payroll_hours.length; i++) {
                if(user.payroll_hours[i].data) {
                    var inlist = $filter('filter')(user.payroll_hours[i].data,{'manager_id': $scope.user._id}, true);
                    if(inlist.length > 0) {
                        remove = false;
                        if(inlist.length === user.payroll_hours[i].data.length) {
                            user.payroll_hours[i].type = 'regular';
                        } else {
                            user.payroll_hours[i].type = 'diffhours';
                        }
                    }
                }
            }
        }

        if($scope.is_foreman) {
            for(var i=0; i<user.payroll_hours.length; i++) {
                if(user.payroll_hours[i].data) {
                    var inlist = $filter('filter')(user.payroll_hours[i].data,{'foreman_id': $scope.user._id}, true);
                    if(inlist.length > 0) {
                        remove = false;
                        if(inlist.length === user.payroll_hours[i].data.length) {
                            user.payroll_hours[i].type = 'regular';
                        } else {
                            user.payroll_hours[i].type = 'diffhours';
                        }
                    }
                }
            }
        }

        return remove;


    	// var result = $filter('filter')(usr.payroll_hours, {'type': 'regular'}, true);
    	// _.remove(result, function(item) {
    	// 	return item.hours === 0;
    	// });
    	// return result.length === 0;
    };

    $scope.getAdminHours = function() {
        var deferred = $q.defer();
        var returned_items = [];
        $scope.payroll_hours = [];

        //gets all project hours
        $scope.getProjectHours().then(function(payroll_hours) {
            $scope.payroll_hours = payroll_hours;
            $q.all($scope.payroll_hours).then(function(results) {
                deferred.resolve(results);
            });
        });

        return deferred.promise;
    };

    $scope.getProjectHours = function() {
        var deferred = $q.defer();
        var returned_items = [];

        ProjectHours.query({'trade': $scope.trade.trade, 
            'company_code': $scope.trade.company_code,
            'type': 'dateRange',
            'populate': true,
            'start': new Date($scope.payStartDate), 
            'end': new Date($scope.payEndDate) }, function(payroll_hours) {
            _.each(payroll_hours, function(hour) {
                returned_items.push(hour);
            });

            $q.all(returned_items).then(function(results) {
                deferred.resolve(results);
            });
        });

        return deferred.promise;
    };

    $scope.getUserProjectHours = function(uName) {
        var deferred = $q.defer();
        //var returned_items = [];

        ProjectHours.query({'trade': $scope.trade.trade, 
            'company_code': $scope.trade.company_code,
            'type': 'userDateRange',
            'username': uName,
            'start': new Date($scope.payStartDate), 
            'end': new Date($scope.payEndDate) }, function(payroll_hours) {

                deferred.resolve(payroll_hours);
        });

        return deferred.promise;
    };

    $scope.getProjects = function() {
        var deferred = $q.defer();
        var returned_items = [];

        Projects.query({
            'company_code': $scope.trade.company_code,
            'trade_code': $scope.trade.trade_code,
            'manager': $scope.user.username,
            'complete': false,
            'match_string_for_manager': true,
            'username': $scope.main_account.username }
            , function(projects) {
            _.each(projects, function(project) {
                returned_items.push(project);
            });

            $q.all(returned_items).then(function(results) {
                deferred.resolve(results);
            });
        });

        return deferred.promise;
    };

    $scope.getManagerHours = function() {
        $scope.payroll_hours = [];
        var deferred = $q.defer();
        var returned_items = [];
        
        $scope.getProjects().then(function(projects) {
            $scope.getProjectHours().then(function(payroll_hours) {
                _.each(projects, function(project) {
                    //var hours = $filter('filter')(payroll_hours, {'project_id._id': project._id}, true);
                    var hours = _.remove(payroll_hours, function(item) {
                        return item.project_id._id === project._id;
                    });

                    _.each(hours, function(hour) {
                       $scope.payroll_hours.push(hour);
                    });
                });

                _.each(payroll_hours, function(hour) {
                	var hours = $filter('filter')($scope.payroll_hours, {'_id': hour._id}, true);

                	if(hours.length === 0) {
                		hour.different_project = true;
                		$scope.payroll_hours.push(hour);
                	}
                });

                $q.all($scope.payroll_hours).then(function(results) {
                    deferred.resolve(results);
                });
            });
        });

        return deferred.promise;
    };

    $scope.getForemanHours = function() {
    	$scope.payroll_hours = [];
        var deferred = $q.defer();
        var returned_items = [];

        //now get all the project hours given the payroll date period
        $scope.getProjectHours().then(function(payroll_hours) {
        	_.each(payroll_hours, function(hour) {
            	if(hour.foreman_id === $scope.user._id) {
            		hour.different_project = false;
            	} else {
            		hour.different_project = true;
            	}
            	$scope.payroll_hours.push(hour);
            });

            $q.all($scope.payroll_hours).then(function(results) {
                deferred.resolve(results);
            });
        });

        return deferred.promise;
    };

    $scope.init = function() {

    };

    $scope.onSelect = function(item) {
        $scope.current_menu = item;
    };

    $scope.changeForeman = function() {
        $scope.dateRangeUpdated();
    };

    $scope.changeEmployee = function() {
        if(!$scope.selectedEmployee) return;

        //managers can view all time cards
        if($scope.is_manager) {
            $scope.getUserHours($scope.selectedEmployee);
        } else {
            if($scope.selectedEmployee.username != $scope.user.username) {
                $scope.userIsVerified = false;
                $scope.verifiedUser = null;

                $scope.returnedOptions = {
                    username: $scope.selectedEmployee.username,
                    password: '',
                    type: 'TimeCardVerification'
                };

                loginDialog = ngDialog.open({
                    template: 'foreman/views/tmpl/password.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default'
                });
            } else {
                $scope.userIsVerified = true;
                $scope.verifiedUser = $scope.user;
                $scope.getUserHours($scope.user);
            }
        }
    };

    $scope.changePayrollEmployee = function(employee) {
        if(!employee) return;

        if(employee.roles[0] === 'tm_admin') {
            $scope.is_manager = true;
            $scope.is_admin = true;
            $scope.is_foreman = false;
        } else if(employee.roles[0] === 'tm_office') {
            $scope.is_manager = true;
            $scope.is_admin = true;
            $scope.is_foreman = false;
        } else if (employee.roles[0] === 'tm') {
            $scope.is_manager = true;
            $scope.is_admin = false;
            $scope.is_foreman = false;
        } else if(employee.roles[0] === 'foreman') {
            $scope.is_foreman = true;
            $scope.is_manager = false;
            $scope.is_admin = false;
        } else {
            $scope.is_manager = false;
            $scope.is_admin = false;
            $scope.is_foreman = false;
        }

        $scope.user = employee;

        $scope.changePayrollPeriod();
        if($scope.user.roles[0] == 'tradesman') {
            $scope.getUserHours($scope.user);
        }
    };

    $scope.ranges = {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 days': [moment().subtract(7, 'days'), moment()],
        'Last 30 days': [moment().subtract(30, 'days'), moment()],
        'This month': [moment().startOf('month'), moment().endOf('month')]
    };

    $scope.selectedItem = function(idx) {
        $scope.selectedDate = $scope.report_dates[idx];
        var curr_date = new moment($scope.report_dates[idx].date);
        var curr_hours = [];
        $scope.consolidatedEmp = [];
        var current_foreman = [];

        if($scope.is_manager) {
            current_foreman = $filter('filter')($scope.current_foremen, {'name': $scope.selectedDate.foreman}, true);

            if(current_foreman.length !== 1) {
                toaster.pop('error', 'Foreman Error', 
                    'Got more than one foreman for the listing.  Contact Admin');
                return;
            } 
        } else {
            current_foreman.push($scope.user);
        }

        var hours = $filter('filter')($scope.hours, {'foreman_id': current_foreman[0]._id}, true);

        hours.forEach(function(hour) {
            var test = new moment(hour.date);
            if(test.startOf('day').isSame(curr_date.startOf('day'))) {
                var task = $filter('filter')($scope.tasks, {'_id': hour.project_task_id}, true);
                if(task.length !== 1) {
                    //toaster.pop('error', 'ProjectTasks Error', 
                    //  'There was a problem with getting the task for the report.  Contact Admin');
                    return;
                }

                console.log('Starting employee list size is: ' + $scope.consolidatedEmp.length);
                var emp = $filter('filter')($scope.consolidatedEmp, {'username': hour.username}, true);

                var proj = $filter('filter')($scope.working_projects, {'project_id': task[0].project_id}, true);

                if(proj.length !== 1) {
                    toaster.pop('error', 'Project Error', 
                        "There was a problem getting the project information.  Contact Admin.");
                    return;
                }

                var code_string = task[0].job_code + '-' + proj[0].project_name + '-' + task[0].phase + '-' + task[0].lot 
                                    + '-' + task[0].task_code;

                if(emp.length === 0) {
                    //curent hour employee is not in our list
                    $scope.consolidatedEmp.push({
                        name: hour.name,
                        username: hour.username,
                        total_hours: hour.hours,
                        total_costs: hour.hours * hour.rate,
                        tasks: [{
                            code: code_string,
                            date: hour.date,
                            hours: hour.hours,
                            cost: hour.hours * hour.rate,
                            completed: (task[0].date_completed)?true:false
                        }]
                    })
                } else if(emp.length === 1) {
                    console.log('The employee is in the list so we are adding hours');
                    emp[0].total_hours += hour.hours;
                    emp[0].total_costs += hour.hours * hour.rate;
                    emp[0].tasks.push({
                        code: code_string,
                        date: hour.date,
                        hours: hour.hours,
                        cost: hour.hours * hour.rate,
                        completed: (task[0].date_completed)?true:false
                    });
                } else {
                    toaster.pop('error', 'Employee Error', 
                        'Got too many employees back for ' + hour.username + '. Contact Admin!');
                    return;
                }
            }
                
        });
        

        $scope.view = 'report';
    };

    $scope.back = function() {
        $scope.total_hours = 0;
        $scope.total_costs = 0;
        $scope.dateRangeUpdated();
        $scope.view = '';
        $scope.consolidatedEmp = [];
    };

    $scope.switchReportView = function() {
        if($scope.report_view === 'task') {
            $scope.report_view = 'employee';
        } else {
            $scope.report_view = 'task';
        }
    }

    $scope.dateRangeUpdated = function() {
        if(!$scope.selectedForeman) return;

        $scope.startDate = new Date($scope.reportDateRange.startDate);
        $scope.endDate = new Date($scope.reportDateRange.endDate);
        $scope.consolidatedEmp = [];

        $scope.startDate.setHours(0);
        $scope.startDate.setMinutes(0);
        $scope.startDate.setSeconds(0);
        $scope.endDate.setHours(23);
        $scope.endDate.setMinutes(59);
        $scope.endDate.setSeconds(59);
        $scope.report_dates = [];
        var foreman = '';
        $scope.tasks = [];
        $scope.working_projects = [];

        if($scope.selectedForeman.name === 'ALL') {
            for(var i=1; i<$scope.current_foremen.length; i=i+1) {
                console.log('Id value ' + $scope.current_foremen[i]._id + ' at index ' + i);
                foreman = $scope.current_foremen[i];
                //get all the project tasks that the current foreman is associated with
                ProjectTasks.query({'foreman.username': foreman.username,
                    'complete': false }, function(tasks) {
                    
                    if(tasks.length !== 0) {
                        tasks.forEach(function(task) {
                            var is_here = $filter('filter')($scope.working_projects, {'project_id': task.project_id}, true);

                            if(is_here.length === 0) {
                                $scope.working_projects.push({
                                    project_id: task.project_id,
                                    project_task_id: task._id
                                });
                            }
                        });

                        var curr_date = moment($scope.startDate);
                        var end_date = moment($scope.endDate);
                        $scope.tasks = $scope.tasks.concat(tasks);
                        $scope.hours = [];
                        var index = 0;
                        var temp_foreman = $filter('filter')($scope.current_foremen, {'name': tasks[0].foreman.name}, true);

                        if(temp_foreman.length !== 1) {
                            toaster.pop('error', 'Foreman Error', 'Problem with getting the correct foreman information. Contact Admin');
                            return;
                        }

                        //now get all the hours in the selected date range
                        ProjectHours.query({'type': 'dateRangeAndForemanID', 
                                'start': $scope.startDate, 'end': $scope.endDate,
                                'foreman_id': temp_foreman[0]._id }, function(hours) {

                            if(curr_date.format($scope.dateFormat) === end_date.format($scope.dateFormat)) {
                                if(hours.length > 0) {
                                    $scope.report_dates.push({
                                        date: new Date(curr_date),
                                        foreman: temp_foreman[0].name
                                    });
                                    $scope.hours = $scope.hours.concat(hours);;
                                }                   
                            } else {
                                end_date.add(1, 'days');  //increment one to the end to get the current day as well.
                                
                                while(curr_date.format($scope.dateFormat) !== end_date.format($scope.dateFormat)) {
                                    var curr_hours = [];

                                    hours.forEach(function(hour) {
                                        var test = new moment(hour.date);
                                        if(test.startOf('day').isSame(curr_date.startOf('day')))
                                            curr_hours.push(hour);
                                    });

                                    if(curr_hours.length > 0) {
                                        $scope.report_dates.push({
                                            date: new Date(curr_date),
                                            foreman: temp_foreman[0].name
                                        });
                                        $scope.hours = $scope.hours.concat(curr_hours);
                                        //angular.extend($scope.hours, curr_hours);
                                        //$scope.hours.push(curr_hours);
                                    } 
                                    
                                    curr_date.add(1, 'days');
                                }
                            }
                        });

                        $scope.working_projects.forEach(function(proj) {
                            Projects.query({'_id': proj.project_id, 'complete': false }, function(project) {
                                if(project.length !== 1) {
                                    toaster.pop('error', 'Project Error',
                                        'There was a problem retrieving the project information from the database.  Contact Admin.');
                                    return;
                                }
                                proj.project_name = project[0].name;
                            });
                        });

                        $scope.view = 'dates';
                    }
                });
            }
        } else {
            //get all the project tasks that the current foreman is associated with
            ProjectTasks.query({'foreman.username': $scope.selectedForeman.username,
                'complete': false }, function(tasks) {
                
                if(tasks.length !== 0) {
                    $scope.working_projects = [];

                    tasks.forEach(function(task) {
                        var is_here = $filter('filter')($scope.working_projects, {'project_id': task.project_id}, true);

                        if(is_here.length === 0) {
                            $scope.working_projects.push({
                                project_id: task.project_id,
                                project_task_id: task._id
                            });
                        }
                    });

                    var curr_date = moment($scope.startDate);
                    var end_date = moment($scope.endDate);
                    $scope.tasks = tasks;
                    $scope.hours = [];
                    var index = 0;

                    //now get all the hours in the selected date range
                    ProjectHours.query({'type': 'dateRangeAndForemanID', 
                            'start': $scope.startDate, 'end': $scope.endDate,
                            'foreman_id': $scope.selectedForeman._id}, function(hours) {

                        if(curr_date.format($scope.dateFormat) === end_date.format($scope.dateFormat)) {
                            if(hours.length > 0) {
                                $scope.report_dates.push({
                                    date: new Date(curr_date),
                                    foreman: $scope.selectedForeman.name
                                });
                                $scope.hours = $scope.hours.concat(hours);;
                            }                   
                        } else {
                            end_date.add(1, 'days');  //increment one to the end to get the current day as well.
                            
                            while(curr_date.format($scope.dateFormat) !== end_date.format($scope.dateFormat)) {
                                var curr_hours = [];

                                hours.forEach(function(hour) {
                                    var test = new moment(hour.date);
                                    if(test.startOf('day').isSame(curr_date.startOf('day')))
                                        curr_hours.push(hour);
                                });

                                if(curr_hours.length > 0) {
                                    $scope.report_dates.push({
                                        date: new Date(curr_date),
                                        foreman: $scope.selectedForeman.name
                                    });
                                    $scope.hours = $scope.hours.concat(curr_hours);
                                    //angular.extend($scope.hours, curr_hours);
                                    //$scope.hours.push(curr_hours);
                                } 
                                
                                curr_date.add(1, 'days');
                            }
                        }
                    });

                    $scope.working_projects.forEach(function(proj) {
                        Projects.query({'_id': proj.project_id, 'complete': false }, function(project) {
                            if(project.length !== 1) {
                                toaster.pop('error', 'Project Error', 
                                    'There was a problem retrieving the project information from the database.  Contact Admin.');
                                return;
                            }
                            proj.project_name = project[0].name;
                        });
                    });

                    $scope.view = 'dates';
                }
            });
        }
    };

    $rootScope.$on('verifyfailed', function(event, data){
        toaster.pop('error', 'Password Incorrect');
        if(!loginDialog) return;

        loginDialog.close();

        $scope.userIsVerified = false;

        loginDialog = null;
    });

    $rootScope.$on('userVerifiedTC', function(event, data){
        console.log('verified user identity for timecard');
        if(!loginDialog) return;

        console.log(event);
        console.log(data);
        loginDialog.close();
        
        $scope.userIsVerified = true;

        $scope.verifiedUser = $filter('filter')($scope.users, {'username': data.username}, true)[0];

        if(!$scope.verifiedUser) {
            toaster.pop('error', 'User Error', 'Failed to find user.  Contact Admin.');
        }

        $scope.getUserHours($scope.verifiedUser);

        loginDialog = null;
    });

    $rootScope.$on('userVerifiedTCSign', function(event, data){
        console.log('verified user identity for timecard');
        if(!loginDialog) return;

        console.log(event);
        console.log(data);
        loginDialog.close();

        $scope.verifiedUser = $filter('filter')($scope.users, {'username': data.username}, true)[0];

        if(!$scope.verifiedUser) {
            toaster.pop('error', 'User Error', 'Failed to find user.  Contact Admin.');
        }

        myCoordinates.get().then(function(coords) {
            //user_hours represent every day of the pay period.
            //remove the days not worked.
            var save_hours = angular.copy($scope.user_hours);

            _.remove(save_hours, function(hour) {
                return hour._id === undefined;
            });

            if($scope.userTimeCard) {
                $scope.userTimeCard.hours = save_hours;
                $scope.userTimeCard.signed = true;
                $scope.userTimeCard.info = {
                    date: new Date(),
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    code: 'E'
                };
                $scope.userTimeCard.total = {
                    hours: $scope.userTotals.hours,
                    overtime_hours: $scope.userTotals.ot_hours,
                    double_hours: $scope.userTotals.dt_hours,
                    production_bonus: $scope.userTotals.production_bonus,
                    effective_rate: $scope.userTotals.effective_rate,
                    extra_break_money: $scope.userTotals.break_pay,
                    premium_overtime: $scope.userTotals.premium_ot
                }

                $scope.userTimeCard.$update(function(success) {
                    $scope.userTimeCard = success;
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
                    toaster.pop('success', 'Time Card Signed');
                }, function(error) {
                    toaster.pop('error', 'Time Card Error', error);
                });
            } else {
                var tc = new Timecards({
                    user: $scope.verifiedUser,
                    trade_code: userService.getTradeCode($scope.verifiedUser.username),
                    company_code: $scope.verifiedUser.contractor_code,
                    start_date: new Date($scope.payStartDate),
                    end_date: new Date($scope.payEndDate),
                    hours: save_hours,
                    signed: true,
                    info: { //info at the time of signing
                        date: new Date(),
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        code: 'E'
                    },
                    total: {
                        hours: $scope.userTotals.hours,
                        overtime_hours: $scope.userTotals.ot_hours,
                        double_hours: $scope.userTotals.dt_hours,
                        production_bonus: $scope.userTotals.production_bonus,
                        effective_rate: $scope.userTotals.effective_rate,
                        extra_break_money: $scope.userTotals.break_pay,
                        premium_overtime: $scope.userTotals.premium_ot
                    }
                });

                tc.$save(function(success) {
                    $scope.userTimeCard = success;
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
                    toaster.pop('success', 'Time Card Signed');
                }, function(error) {
                    toaster.pop('error', 'Time Card Error', error);
                })
            }
        });

        loginDialog = null;
    });

    $scope.getUserHours = function(vUser) {
        if(!$scope.selectedPayPeriod || !$scope.selectedPayPeriod.string) return;
        if(!$scope.selectedEmployee || !$scope.selectedEmployee.username) return;

        $scope.userTotals = {
            hours: 0,
            hours_ms: 0,
            ot_hours: 0,
            dt_hours: 0,
            production_bonus: 0,
            effective_rate: 0,
            break_pay: 0,
            premium_ot: 0
        }

        $scope.user_hours = [];
        var current_day = new moment($scope.payStartDate);
        $scope.user_hours = _.times($scope.biweekly?14:7, function() {
            var obj = {
                date: current_day.clone(),
                total: 0,
                task_hours: 0,
                production_bonus: 0,
                extra_break_money: 0,
                hours_over_time: 0,
                hours_double_time: 0,
                premium_overtime: 0,
                clock_in: {
                    time: null
                },
                lunch_start: {
                    time: null
                },
                lunch_end: {
                    time: null
                },
                clock_out: {
                    time: null
                },
            }
            current_day = new moment(current_day.add(1, 'day'));
            return obj;
        });

        if(!$scope.biweekly) {
            for(var i=0; i<7; i++) {
                $scope.user_hours.push({
                    'dummy': true
                });
            }
        }

        Timecards.query({'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'user': vUser._id,
            'type': 'UserDateRange',
            'start_date': $scope.payStartDate.toDate(),
            'end_date': $scope.payEndDate.toDate() }, function(timecardDB) {

            //var today = moment();
            //moment(pHour.date).isSame(moment(curr_date), 'day')
            var found = _.remove(timecardDB, function(tc) {
                return moment(tc.start_date).isSame($scope.payStartDate, 'day') &&
                    moment(tc.end_date).isSame($scope.payEndDate, 'day');
            });

            if(found && found.length === 1) {
                _.each(found[0].hours, function(time) {
                    time.date = moment(time.date);
                    if(time.clock_in)
                        time.clock_in.time = moment(time.clock_in.time);//.format("h:mm:ss a");
                    if(time.lunch_start)
                        time.lunch_start.time = moment(time.lunch_start.time);
                    if(time.lunch_end)
                        time.lunch_end.time = moment(time.lunch_end.time);
                    if(time.clock_out)
                        time.clock_out.time = moment(time.clock_out.time);

                    var first = null;
                    var second = null;

                    if(time.lunch_start && time.clock_in)
                        first = moment.duration(time.lunch_start.time.diff(time.clock_in.time));

                    if(time.clock_out && time.lunch_end.time)
                        second = moment.duration(time.clock_out.time.diff(time.lunch_end.time));

                    if(first !== null && second !== null) {
                        var final = moment.duration(first.add(second));
                        time.total = final.asHours();
                    } 
                });

                var ordered = $filter('orderBy')(found[0].hours, 'date');
                var hours_data = ordered;
                
                _.each(hours_data, function(uHour) {
                    uHour.task_hours = 0;
                    uHour.production_bonus = 0;
                    uHour.extra_break_money = 0;
                    uHour.hours_over_time = 0;
                    uHour.hours_double_time = 0;
                    uHour.premium_overtime = 0;
                });

                $scope.getUserProjectHours(vUser.username).then(function(pHours) {
                    $scope.combineHoursData($scope.payStartDate, $scope.payEndDate, pHours, hours_data);
                });

                $scope.userTotals = {
                    hours: found[0].total.hours,
                    //hours_ms: 0,
                    ot_hours: found[0].total.overtime_hours,
                    dt_hours: found[0].total.double_hours,
                    production_bonus: found[0].total.production_bonus,
                    effective_rate: found[0].total.effective_rate,
                    break_pay: found[0].total.extra_break_money,
                    premium_ot: found[0].total.premium_overtime
                }

                $scope.userTimeCard = found[0];
                if($scope.userTimeCard.info) {
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
                }
            } else if(found.length > 1) {
                toaster.pop('error', 'Time Card Error', 'Contact Admin');
            } else {
                $scope.getHoursData(vUser);
                $scope.userTimeCard = null;
            }
        });
    };

    $scope.getHoursData = function(vUser) {
        Hours.query({ 'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'type': 'UserDateRange',
            'user': vUser._id,
            'start': new Date($scope.payStartDate),
            'end': new Date($scope.payEndDate) }, function(timesdb) {
            _.each(timesdb, function(time) {
                time.date = moment(time.date);
                if(time.clock_in)
                    time.clock_in.time = moment(time.clock_in.time);//.format("h:mm:ss a");
                if(time.lunch_start)
                    time.lunch_start.time = moment(time.lunch_start.time);
                if(time.lunch_end)
                    time.lunch_end.time = moment(time.lunch_end.time);
                if(time.clock_out)
                    time.clock_out.time = moment(time.clock_out.time);

                var first = null;
                var second = null;

                if(time.lunch_start && time.clock_in)
                    first = moment.duration(time.lunch_start.time.diff(time.clock_in.time));

                if(time.clock_out && time.lunch_end.time)
                    second = moment.duration(time.clock_out.time.diff(time.lunch_end.time));

                if(first !== null && second !== null) {
                    var final = moment.duration(first.add(second));
                    time.total = final.asHours();
                    //time.seconds = parseFloat(final.asSeconds());
                } else {
                    time.total = 0;
                }
            });

            var ordered = $filter('orderBy')(timesdb, 'date');
            var hours_data = ordered;
            //var seconds = 0;
            _.each(hours_data, function(uHour) {
                uHour.task_hours = 0;
                uHour.production_bonus = 0;
                uHour.extra_break_money = 0;
                uHour.hours_over_time = 0;
                uHour.hours_double_time = 0;
                uHour.premium_overtime = 0;
                //seconds += uHour.seconds;
            });

            //$scope.userTotals.hours = seconds;

            $scope.getUserProjectHours(vUser.username).then(function(pHours) {
                $scope.combineHoursData($scope.payStartDate, $scope.payEndDate, pHours, hours_data);
            });
        });
    };

    $scope.combineHoursData = function(start, end, projectHours, clockHours) {
        var end_date = moment(end).startOf('day');
        var curr_date = moment(start).startOf('day');

        $scope.userTotals = {
            hours: 0,
            ot_hours: 0,
            dt_hours: 0,
            production_bonus: 0,
            effective_rate: 0,
            break_pay: 0,
            premium_ot: 0,
        }

        var idx = 0;
        while(curr_date.diff(end_date) <= 0) {
            var pHours = _.remove(projectHours, function(pHour) {
                return moment(pHour.date).isSame(moment(curr_date), 'day')
            });
            var cHours = _.remove(clockHours, function(cHour) {
                return moment(cHour.date).isSame(moment(curr_date), 'day')
            });

            if(cHours.length > 1) {
                toaster.pop('error', 'Clock Hours Error', 'Not expecting this to happen');
            } else if(cHours.length === 1) {
                $scope.user_hours.splice(idx, 1, cHours[0]);
            }

            var view_data = $scope.user_hours[idx];

            if(cHours.length === 0 && pHours.length > 0) {
                //this use case means we have logged project hours but
                //the user has not created any clock hours 
                _.each(pHours, function(hour) {
                    view_data.task_hours += hour.hours;
                    view_data.hours_over_time += hour.hours_over_time;
                    view_data.hours_double_time += hour.hours_double_time;
                    view_data.extra_break_money += hour.extra_break_money;
                    view_data.premium_overtime += hour.premium_overtime;
                    view_data.production_bonus += hour.production_bonus;
                });
            } else {
                _.each(pHours, function(hour) {
                    view_data.task_hours += hour.hours;
                    view_data.hours_over_time += hour.hours_over_time;
                    view_data.hours_double_time += hour.hours_double_time;
                    view_data.extra_break_money += hour.extra_break_money;
                    view_data.premium_overtime += hour.premium_overtime;
                    view_data.production_bonus += hour.production_bonus;
                });
            }

            if(view_data) {
                $scope.userTotals.hours += (view_data.task_hours)?view_data.task_hours:0;
                $scope.userTotals.ot_hours += view_data.hours_over_time;
                $scope.userTotals.dt_hours += view_data.hours_double_time;
                $scope.userTotals.production_bonus += view_data.production_bonus;
                $scope.userTotals.effective_rate += (view_data.effective_rate)?view_data.effective_rate:0;
                $scope.userTotals.break_pay += view_data.extra_break_money;
                $scope.userTotals.premium_ot += view_data.premium_overtime;
            }

            idx++;
            curr_date.add(1, 'days')
        }

        console.log('finished')
    };

    $scope.signTimeCard = function() {
        $scope.returnedOptions = {
            username: $scope.selectedEmployee.username,
            password: '',
            type: 'TimeCardSignVerification'
        };

        loginDialog = ngDialog.open({
            template: 'foreman/views/tmpl/password.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        });
    };

    $scope.printTimeCard = function() {
        html2canvas(document.getElementById('employeeTimeCardTable')).then((canvas) => {
            var data = canvas.toDataURL();
            var docDefinition = {
                pageMargins: [ 10, 70, 10, 20 ],
                pageSize: 'A4',
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-Italic.ttf'
                },
                header: [{
                    canvas: [{
                        type: 'line',
                        x1: 10,
                        y1: 10,
                        x2: 595-10,
                        y2: 10,
                        lineWidth: 0.5
                    }]
                }, {
                   fontSize: 8,
                   columns : [{
                       text : 'A.C.E. Construction Software',
                       margin : [ 10, 0, 0, 0 ],
                       width : 100
                    }]
                }, {
                   fontSize: 8,
                   columns : [{
                        text : 'Time Card',
                        margin : [ 10,0,0,0 ],
                        width : 100
                    }]
                }, {
                    canvas: [{
                        type: 'line',
                        x1: 10,
                        y1: 0,
                        x2: 595-10,
                        y2: 0,
                        lineWidth: 0.5
                    }]
                }],
                content: [{
                    image: data,
                    width: 550,
                }],
                defaultStyle: {
                    font: 'Roboto'
                }
            };
            pdfMake.createPdf(docDefinition).open();
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/foreman_past.js